import { apiSlice } from '../apiSlice';
import { SuccessResponse } from '../DTO/common.interface';
import { TaskRuleDescriptionDTO } from '../DTO/task/rule.interface';

export const ruleApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getRuleList: builder.query<SuccessResponse<TaskRuleDescriptionDTO[]>, null>(
			{
				query: () => ({
					url: `/web/task/rule-description/list`,
					method: 'GET',
				}),
			}
		),
		getRuleDelete: builder.query<
			SuccessResponse<TaskRuleDescriptionDTO>,
			string
		>({
			query: (id) => ({
				url: `/web/task/rule-description/${id}`,
				method: 'GET',
			}),

			providesTags: ['RuleDetail'],
		}),
		updateRuleDelete: builder.mutation<
			SuccessResponse<any>,
			TaskRuleDescriptionDTO
		>({
			query: (body) => ({
				url: `/web/task/rule-description/${body.id}`,
				method: 'PUT',
				body,
			}),

			invalidatesTags: ['RuleDetail'],
		}),
	}),
});

export const {
	useGetRuleListQuery,
	useGetRuleDeleteQuery,
	useUpdateRuleDeleteMutation,
} = ruleApiSlice;
